import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_RECIPIENTS_SUCCESS: {
      return [...action.recipients];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/recipients.js